import script from "./TableDataAccessUser.vue?vue&type=script&setup=true&lang=js"
export * from "./TableDataAccessUser.vue?vue&type=script&setup=true&lang=js"

import "./TableDataAccessUser.vue?vue&type=style&index=0&id=63bfe83e&lang=css"

const __exports__ = script;

export default __exports__